import { useState } from "react";

type ErrorsProps<T> = Partial<Record<keyof T, string>>;

type UseFormFieldsReturn<T = { [k: string]: string }> = [
  Partial<T>,
  ErrorsProps<T>,
  (field: keyof T, value: any) => void,
  React.Dispatch<React.SetStateAction<Partial<T>>>,
  React.Dispatch<React.SetStateAction<Partial<Record<keyof T, string>>>>
];

export function useFormFields<T = { [k: string]: string }>(params?: {
  onChange?: (newValue: Partial<T>) => void;
}) {
  const [fields, setFields] = useState<Partial<T>>({});
  const [errors, setErrors] = useState<ErrorsProps<T>>({});

  const onChangeField = (field: keyof T, value: any) => {
    setFields((prev) => {
      const newValue = { ...prev, [field]: value };
      setErrors((errors) => {
        delete errors[field];
        return { ...errors };
      });
      params?.onChange?.(newValue);
      return newValue;
    });
  };

  return [
    fields,
    errors,
    onChangeField,
    setFields,
    setErrors,
  ] as UseFormFieldsReturn<T>;
}
